import React from "react"
import GenericModal from "@irati/ui/src/GenericModal"
import Flex from "@irati/ui/src/Flex"
import {Body, H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import {useWalletQuery} from "@irati/wallet/hooks/wallet"
import {PaymentCurrencyType, WalletEntityType} from "@irati/types"
import useAuth from "@irati/auth/helpers/auth/useAuth"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import Loading from "@irati/ui/src/Loading"
import Markdown from "@irati/ui/src/Markdown"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

export function PointsBackModal({shown, onClose}: {shown?: boolean; onClose: () => void}) {
  const auth = useAuth()
  const {loading, data: wallet} = useWalletQuery(
    {userId: auth.user?.uuid ?? "", currency: PaymentCurrencyType.Rp, entityType: WalletEntityType.User},
    {fetchPolicy: "network-only"}
  )
  const onConfirm = () => {
    if (wallet?.amount === 0) {
      onClose()
    } else {
      // Logic to handle points back action
      // This could be a function that processes the points back
      console.log("Points back action triggered")
      onClose()
    }
  }
  return (
    <GenericModal show={shown} onHide={onClose} onConfirm={onConfirm} proceedButtonText={"platform.btn.confirm"}>
      <Loading show={loading}>
        <Flex direction="column" gap={4}>
          <H2>
            <FormattedMessage id="platform.pointsBack.modal.title" />
          </H2>
          <Flex justifyContent="center" alignItems="center">
            <Icon icon={IconTypes.rewardPoints} size={96} />
          </Flex>
          <Body marginBottom={4} textAlign="center">
            <Markdown
              source="platform.pointsBack.modal.msg"
              values={{
                points: wallet?.amount / 100,
                fullName: firstnameLastname(auth.user?.invitedBy)
              }}
            />
          </Body>
        </Flex>
      </Loading>
    </GenericModal>
  )
}
